import React, { Component } from "react";
import { connect } from "react-redux";
import Sidebar from "./components/Sidebar";
import Topbar from "./components/Topbar";
import Loading from "../../admin/components/Loading";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import axios from "axios";
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { currency } from "../../../dynamicController";
import i18n from "i18next";

const mySwal = withReactContent(Swal);

const colorSets = [
    {
        headColor: "#c596c4",
        bodyColor: "linear-gradient(135deg , #c8bfde , #a1c3e9)"
    },
    {
        headColor: "#fbcc7d",
        bodyColor: "linear-gradient(135deg , #f6b997 , #f38695)"
    },
    {
        headColor: "#93c9ed",
        bodyColor: "linear-gradient(135deg , #6599d3 , #77cebb)"
    },
    {
        headColor: "#c7a1aa",
        bodyColor: "linear-gradient(135deg , #f2d0e0 , #c6a9d2)"
    },
    {
        headColor: "#b6da98",
        bodyColor: "linear-gradient(135deg , #cee6a9 , #dbde91)"
    }
];

const randomNumber = Math.floor(Math.random() * colorSets.length);
const selectedColor = colorSets[randomNumber];

class ReferralSetting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toggled: false,
            referral: false,
            loading: true,
            enableToken: false,
            stamp: false,
            combined: false,
            specificStamp: "",
            loyalty_point: false,
            tiers: []
        };
    }

    componentDidMount() {
        if (!this.props.distributor || !this.props.distributor.referral_setting) {
            return this.props.history.push('/distributor');
        } else {
            axios.post('/api/distributor/setting/getReferralSettings', { distributorId: this.props.distributor.distributorId }, { headers: { "Content-Type": "application/json", "auth-token": this.props.token } })
                .then(res => {
                    this.setState({
                        ...this.state,
                        loading: false,
                        referral: res.data.referral,
                        enableToken: res.data.token,
                        stamp: res.data.stamp,
                        combined: res.data.combined,
                        specificStamp: res.data.specificStamp,
                        loyalty_point: res.data.loyalty_point,
                        tiers: res.data.referralSetting.map(setting => ({
                            ...setting.voucher_setting,
                            token_eligible: setting.token_eligible,
                            token_type: setting.token_type,
                            token_amount: setting.token_amount,
                            stamp_eligible: setting.stamp_eligible,
                            stamp_combined: setting.stamp_combined,
                            stamp_washer: setting.stamp_washer,
                            stamp_dryer: setting.stamp_dryer,
                            point_eligible: setting.point_eligible,
                            point_type: setting.point_type,
                            point_amount: setting.point_amount,
                            number_of_referral: setting.number_of_referral,
                            amount_transaction: setting.amount_transaction,
                            reward_per_user: setting.reward_per_user
                        }))
                    });
                })
                .catch(err => {
                    this.setState({
                        ...this.state,
                        loading: false
                    });
                    mySwal.fire(i18n.t("Error"), i18n.t(err.response.data.error), "error");
                });
        }
    }

    handleToggle = () => this.setState({ ...this.state, toggled: !this.state.toggled });

    handleEnable = e => {
        axios.post("/api/admin/setting/enableReferral", { id: this.props.distributor.distributorId, role: "distributor", data: !this.state.referral }, { headers: { "Content-Type": "application/json", "auth-token": this.props.token } })
            .then(res => {
                this.setState({ ...this.state, referral: res.data.data });
            })
            .catch(err => mySwal.fire(i18n.t("Error"), i18n.t(err.response.data.error), "error"));
    };

    handleCheckbox = (e, index) => {
        const newTiers = [...this.state.tiers];
        newTiers[index][e.target.id] = !newTiers[index][e.target.id];
        this.setState({ ...this.state, tiers: newTiers });
    };

    handleChange = (e, index) => {
        const newTiers = [...this.state.tiers];
        newTiers[index][e.target.id] = e.target.value;
        this.setState({ ...this.state, tiers: newTiers });
    };

    handleSubmit = e => {
        e.preventDefault();

        if (this.state.tiers.length <= 0) {
            mySwal.fire(i18n.t("Error"), i18n.t("Please add at least one tier"), "error");
        } else {
            const sendThis = {
                id: this.props.distributor.distributorId,
                role: "distributor",
                tiers: this.state.tiers
            }

            this.setState({ ...this.state, loading: true });

            axios.post('/api/admin/setting/updateReferral', sendThis, { headers: { "Content-Type": "application/json", "auth-token": this.props.token } })
                .then(res => {
                    this.setState({ ...this.state, loading: false });
                    mySwal.fire({
                        title: i18n.t("Success"),
                        text: i18n.t("The referral setting has been updated successfully!"),
                        icon: "success",
                    });
                })
                .catch(err => {
                    mySwal.fire(i18n.t("Error"), i18n.t(err.response.data.error), "error");
                    this.setState({ ...this.state, loading: false });
                });
        }
    };

    addTier = () => {
        this.setState({
            ...this.state,
            tiers: [...this.state.tiers, {
                voucher_eligible: false,
                voucher_amount: 1,
                voucher_type: "Flat",
                voucher_expiry: true,
                voucher_duration: 30,
                voucher_title: "REFERRAL REWARDS",
                voucher_description: "Thank you for inviting friends, here's your referral rewards. Enjoy!",
                voucher_washer_use: true,
                voucher_dryer_use: false,
                voucher_package_use: false,
                voucher_vending_use: false,
                voucher_detergent_use: false,
                voucher_carwash_use: false,
                token_eligible: false,
                token_type: "Flat",
                token_amount: 1,
                stamp_eligible: false,
                stamp_combined: 1,
                stamp_washer: 1,
                stamp_dryer: 1,
                point_eligible: false,
                point_type: "Flat",
                point_amount: 5,
                number_of_referral: 3,
                amount_transaction: 5,
                reward_per_user: 1
            }]
        });
    };

    deleteTier = (index) => {
        mySwal.fire({
            title: i18n.t("Confirmation"),
            text: i18n.t("Are you sure you want to delete the tier setting?"),
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: i18n.t("Delete"),
            cancelButtonText: i18n.t("No"),
        }).then((result) => {
            if (result.isConfirmed) {
                let newTiers = [...this.state.tiers]
                newTiers.splice(index, 1)
                this.setState({ ...this.state, tiers: newTiers });
            }
        });
    };

    render() {
        const stampSetting = (index) => {
            const tier = this.state.tiers[index];
            if (this.state.combined) {
                return (
                    <div className="form-group">
                        <label htmlFor="stamp_combined">{i18n.t("Number of Stamp")} : </label>
                        <input type="number" id="stamp_combined" name="stamp_combined" value={tier.stamp_combined} onChange={(e) => this.handleChange(e, index)} min="0" required />
                    </div>
                );
            } else {
                if (this.state.specificStamp === "both") {
                    return (
                        <div>
                            <div className="form-group">
                                <label htmlFor="stamp_washer">{i18n.t("Number of Washer Stamp")}: </label>
                                <input type of="number" id="stamp_washer" name="stamp_washer" value={tier.stamp_washer} onChange={(e) => this.handleChange(e, index)} min="0" required />
                            </div>
                            <div className="form-group">
                                <label htmlFor="stamp_dryer">{i18n.t("Number of Dryer Stamp")}: </label>
                                <input type="number" id="stamp_dryer" name="stamp_dryer" value={tier.stamp_dryer} onChange={(e) => this.handleChange(e, index)} min="0" required />
                            </div>
                        </div>
                    );
                } else if (this.state.specificStamp === "washerOnly") {
                    return (
                        <div className="form-group">
                            <label htmlFor="stamp_washer">{i18n.t("Number of Washer Stamp")}: </label>
                            <input type="number" id="stamp_washer" name="stamp_washer" value={tier.stamp_washer} onChange={(e) => this.handleChange(e, index)} min="0" required />
                        </div>
                    );
                } else if (this.state.specificStamp === "dryerOnly") {
                    return (
                        <div className="form-group">
                            <label htmlFor="stamp_dryer">{i18n.t("Number of Dryer Stamp")}: </label>
                            <input type="number" id="stamp_dryer" name="stamp_dryer" value={tier.stamp_dryer} onChange={(e) => this.handleChange(e, index)} min="0" required />
                        </div>
                    );
                }
            }
        };

        return (
            <div id="admin-dashboard" className="admin-page-container">
                <Sidebar toggled={this.state.toggled} setToggled={this.handleToggle} />
                <div className="admin-page">
                    <Topbar handleToggle={this.handleToggle} />
                    <div className="admin-content">
                        {this.state.loading ? <Loading /> : (
                            <div>
                                <div className="mt-4 mb-5">
                                    <div className="form-group">
                                        <label>
                                            <input type="checkbox" id="enable" name="enable" checked={this.state.referral} onChange={this.handleEnable} />
                                            <span>{i18n.t("Enable Referral Feature?")}</span>
                                        </label>
                                    </div>
                                </div>
                                {this.state.referral ? (
                                    <div className="card">
                                        <div className="card-header">
                                            <h5 className="card-title">{i18n.t("Referral Settings")}</h5>
                                        </div>

                                        <form onSubmit={this.handleSubmit}>
                                            <div className="card-body">
                                                {this.state.tiers.map((tier, index) => (
                                                    <div className="card mb-4" key={index}>
                                                        <div className="card-header d-flex justify-content-between align-items-center">
                                                            <span>{i18n.t("Tier")} {index + 1}</span>
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger btn-sm"
                                                                onClick={() => this.deleteTier(index)}
                                                            >
                                                                {i18n.t("Delete")}
                                                            </button>
                                                        </div>

                                                        <div className="card-body">
                                                            <div className="form-group">
                                                                <label htmlFor="amount_transaction">{i18n.t("Minimum referee transaction amount for referrer to get referral rewards")} : <small> ({currency(this.props.distributor.country)})</small></label>
                                                                <input type="number" id="amount_transaction" name="amount_transaction" value={tier.amount_transaction} required onChange={(e) => this.handleChange(e, index)} min="0" />
                                                            </div>

                                                            <div className="form-group">
                                                                <label htmlFor="number_of_referral">{i18n.t("Maximum number of reward within this tier")} : </label>
                                                                <input type="number" id="number_of_referral" name="number_of_referral" value={tier.number_of_referral} required onChange={(e) => this.handleChange(e, index)} min="0" />
                                                            </div>

                                                            <div className="form-group">
                                                                <label htmlFor="reward_per_user">{i18n.t("Maximum number of reward can get from same user")} : </label>
                                                                <input type="number" id="reward_per_user" name="reward_per_user" value={tier.reward_per_user} required onChange={(e) => this.handleChange(e, index)} min="0" />
                                                            </div>

                                                            <div className="d-flex justify-content-between">
                                                                {/* STAMP SETTINGS */}
                                                                {this.state.stamp && (
                                                                    <div className="card" style={{ flex: 1, marginRight: '10px' }}>
                                                                        <div className="card-header">
                                                                            <h6 className="m-0 p-0">{i18n.t("Stamp")}</h6>
                                                                        </div>
                                                                        <div className="card-body">
                                                                            <div className="form-group">
                                                                                <label>
                                                                                    <input type="checkbox" id="stamp_eligible" name="stamp_eligible" checked={tier.stamp_eligible} onChange={(e) => this.handleCheckbox(e, index)} />
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={<Tooltip>{i18n.t("If ticked, the system will give stamp to user")}</Tooltip>}
                                                                                    >
                                                                                        <span>{i18n.t("Eligibility")}</span>
                                                                                    </OverlayTrigger>
                                                                                </label>
                                                                            </div>
                                                                            {stampSetting(index)}
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {/* POINTS SETTINGS */}
                                                                {this.state.loyalty_point && (
                                                                    <div className="card" style={{ flex: 1, marginRight: '10px' }}>
                                                                        <div className="card-header">
                                                                            <h6 className="m-0 p-0">{i18n.t("Point")}</h6>
                                                                        </div>
                                                                        <div className="card-body">
                                                                            <div className="form-group">
                                                                                <label>
                                                                                    <input type="checkbox" id="point_eligible" name="point_eligible" checked={tier.point_eligible} onChange={(e) => this.handleCheckbox(e, index)} />
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={<Tooltip>{i18n.t("If ticked, the system will give points to user")}</Tooltip>}
                                                                                    >
                                                                                        <span>{i18n.t("Eligibility")}</span>
                                                                                    </OverlayTrigger>
                                                                                </label>
                                                                            </div>

                                                                            <div className="form-group">
                                                                                <label htmlFor="point_type">{i18n.t("Point Grant Type")} : </label>
                                                                                <select className="browser-default form-select" id="point_type" name="point_type" value={tier.point_type} onChange={(e) => this.handleChange(e, index)} required>
                                                                                    <option value="" disabled>{i18n.t("Select Point Grant Type")}</option>
                                                                                    <option value="Flat">{i18n.t("Flat")} ({i18n.t("Point")})</option>
                                                                                    <option value="Rate">{i18n.t("Rate")} (%)</option>
                                                                                </select>
                                                                            </div>

                                                                            <div className="form-group">
                                                                                <label htmlFor="point_amount">{i18n.t("Point Amount")} : </label>
                                                                                <input type="number" id="point_amount" name="point_amount" value={tier.point_amount} onChange={(e) => this.handleChange(e, index)} min="0" required />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {/* TOKEN SETTINGS */}
                                                                {this.state.enableToken && (
                                                                    <div className="card" style={{ flex: 1, marginRight: '10px' }}>
                                                                        <div className="card-header">
                                                                            <h6 className="m-0 p-0">{i18n.t("Token")}</h6>
                                                                        </div>
                                                                        <div className="card-body">
                                                                            <div className="form-group">
                                                                                <label>
                                                                                    <input type="checkbox" id="token_eligible" name="token_eligible" checked={tier.token_eligible} onChange={(e) => this.handleCheckbox(e, index)} />
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={<Tooltip>{i18n.t("If ticked, the system will give e-Token to user")}</Tooltip>}
                                                                                    >
                                                                                        <span>{i18n.t("Eligibility")}</span>
                                                                                    </OverlayTrigger>
                                                                                </label>
                                                                            </div>

                                                                            <div className="form-group">
                                                                                <label htmlFor="token_type">{i18n.t("Token Grant Type")} : </label>
                                                                                <select className="browser-default form-select" id="token_type" name="token_type" value={tier.token_type} onChange={(e) => this.handleChange(e, index)} required>
                                                                                    <option value="" disabled>{i18n.t("Select Token Grant Type")}</option>
                                                                                    <option value="Flat">{i18n.t("Flat")} ({i18n.t("Token")})</option>
                                                                                    <option value="Rate">{i18n.t("Rate")} (%)</option>
                                                                                </select>
                                                                            </div>

                                                                            <div className="form-group">
                                                                                <label htmlFor="token_amount">{i18n.t("Number of E-Token")} : </label>
                                                                                <input type="number" id="token_amount" name="token_amount" value={tier.token_amount} onChange={(e) => this.handleChange(e, index)} min="0" required />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>

                                                            {/* VOUCHER SETTINGS */}
                                                            <div className="card mt-3" style={{ width: "100%" }}>
                                                                <div className="card-header">
                                                                    <h6 className="m-0 p-0">{i18n.t("Voucher")}</h6>
                                                                </div>
                                                                <div className="card-body">
                                                                    <div className="voucher mb-5">
                                                                        <div className="voucher-ball left-ball"></div>
                                                                        <div className="voucher-head p-0 m-0" style={{ backgroundColor: selectedColor.headColor }}>
                                                                            <h4 style={{ width: "140px", height: "140px", padding: "18px 0 0 0" }}>{i18n.t("DISCOUNT")}</h4>
                                                                        </div>
                                                                        <div className="voucher-content" style={{ background: selectedColor.bodyColor }}>
                                                                            <div>
                                                                                <h1>{tier.voucher_type === "Flat" ? (`${currency(this.props.distributor.country)}${tier.voucher_amount}`) : (`${tier.voucher_amount}%`)}</h1>
                                                                            </div>
                                                                            <div>
                                                                                <h5>{tier.voucher_title}</h5>
                                                                                <h6>{tier.voucher_description}</h6>
                                                                            </div>
                                                                        </div>
                                                                        <div className="voucher-ball right-ball"></div>
                                                                    </div>
                                                                    <div className="text-center">
                                                                        <div className="row justify-content-center">
                                                                            <div className="col-md-3 col-sm-6 form-group">
                                                                                <label>
                                                                                    <input type="checkbox" id="voucher_eligible" name="voucher_eligible" checked={tier.voucher_eligible} onChange={(e) => this.handleCheckbox(e, index)} />
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={<Tooltip>{i18n.t("If ticked, the system will give voucher to user")}</Tooltip>}
                                                                                    >
                                                                                        <span>{i18n.t("Eligibility")}</span>
                                                                                    </OverlayTrigger>
                                                                                </label>
                                                                            </div>
                                                                            <div className="col-md-3 col-sm-6 form-group">
                                                                                <label>
                                                                                    <input type="checkbox" id="voucher_expiry" name="voucher_expiry" checked={tier.voucher_expiry} onChange={(e) => this.handleCheckbox(e, index)} />
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={<Tooltip>{i18n.t("If ticked, the voucher will have expired date")}</Tooltip>}
                                                                                    >
                                                                                        <span>{i18n.t("Expiry")}</span>
                                                                                    </OverlayTrigger>
                                                                                </label>
                                                                            </div>
                                                                            <div className="col-md-3 col-sm-6 form-group">
                                                                                <label>
                                                                                    <input type="checkbox" id="voucher_washer_use" name="voucher_washer_use" checked={tier.voucher_washer_use} onChange={(e) => this.handleCheckbox(e, index)} />
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={<Tooltip>{i18n.t("If ticked, the voucher can apply to washer machine transaction")}</Tooltip>}
                                                                                    >
                                                                                        <span>{i18n.t("Washer Use")}</span>
                                                                                    </OverlayTrigger>
                                                                                </label>
                                                                            </div>
                                                                            <div className="col-md-3 col-sm-6 form-group">
                                                                                <label>
                                                                                    <input type="checkbox" id="voucher_dryer_use" name="voucher_dryer_use" checked={tier.voucher_dryer_use} onChange={(e) => this.handleCheckbox(e, index)} />
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={<Tooltip>{i18n.t("If ticked, the voucher can apply to dryer machine transaction")}</Tooltip>}
                                                                                    >
                                                                                        <span>{i18n.t("Dryer Use")}</span>
                                                                                    </OverlayTrigger>
                                                                                </label>
                                                                            </div>
                                                                            <div className="col-md-3 col-sm-6 form-group">
                                                                                <label>
                                                                                    <input type="checkbox" id="voucher_package_use" name="voucher_package_use" checked={tier.voucher_package_use} onChange={(e) => this.handleCheckbox(e, index)} />
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={<Tooltip>{i18n.t("If ticked, the voucher can apply to Drop n Go transaction")}</Tooltip>}
                                                                                    >
                                                                                        <span>{i18n.t("Package Use")}</span>
                                                                                    </OverlayTrigger>
                                                                                </label>
                                                                            </div>
                                                                            <div className="col-md-3 col-sm-6 form-group">
                                                                                <label>
                                                                                    <input type="checkbox" id="voucher_vending_use" name="voucher_vending_use" checked={tier.voucher_vending_use} onChange={(e) => this.handleCheckbox(e, index)} />
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={<Tooltip>{i18n.t("If ticked, the voucher can apply to vending machine transaction")}</Tooltip>}
                                                                                    >
                                                                                        <span>{i18n.t("Vending Use")}</span>
                                                                                    </OverlayTrigger>
                                                                                </label>
                                                                            </div>
                                                                            <div className="col-md-3 col-sm-6 form-group">
                                                                                <label>
                                                                                    <input type="checkbox" id="voucher_detergent_use" name="voucher_detergent_use" checked={tier.voucher_detergent_use} onChange={(e) => this.handleCheckbox(e, index)} />
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={<Tooltip>{i18n.t("If ticked, the voucher can apply to detergent vending machine transaction")}</Tooltip>}
                                                                                    >
                                                                                        <span>{i18n.t("Detergent Use")}</span>
                                                                                    </OverlayTrigger>
                                                                                </label>
                                                                            </div>
                                                                            <div className="col-md-3 col-sm-6 form-group">
                                                                                <label>
                                                                                    <input type="checkbox" id="voucher_carwash_use" name="voucher_carwash_use" checked={tier.voucher_carwash_use} onChange={(e) => this.handleCheckbox(e, index)} />
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={<Tooltip>{i18n.t("If ticked, the voucher can apply to car wash transaction")}</Tooltip>}
                                                                                    >
                                                                                        <span>{i18n.t("Car Wash Use")}</span>
                                                                                    </OverlayTrigger>
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {tier.voucher_expiry && (
                                                                        <div className="form-group">
                                                                            <label htmlFor="voucher_duration">{i18n.t("Voucher Lifespan")} : <small> ({i18n.t("days")})</small></label>
                                                                            <input type="number" id="voucher_duration" name="voucher_duration" value={tier.voucher_duration} onChange={(e) => this.handleChange(e, index)} min="0" required />
                                                                        </div>
                                                                    )}
                                                                    <div className="form-group">
                                                                        <label htmlFor="voucher_type">{i18n.t("Discount Type")} : </label>
                                                                        <select className="browser-default form-select" id="voucher_type" name="voucher_type" value={tier.voucher_type} onChange={(e) => this.handleChange(e, index)} required>
                                                                            <option value="" disabled>{i18n.t("Select a discount type")}</option>
                                                                            <option value="Flat">{i18n.t("Flat")} (- {currency(this.props.distributor.country)})</option>
                                                                            <option value="Rate">{i18n.t("Rate")} (- %)</option>
                                                                        </select>
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label htmlFor="voucher_title">{i18n.t("Voucher Title")} : </label>
                                                                        <input type="text" id="voucher_title" name="voucher_title" placeholder={i18n.t("Voucher Title")} value={tier.voucher_title} onChange={(e) => this.handleChange(e, index)} required />
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label htmlFor="voucher_description">{i18n.t("Voucher Description")} : </label>
                                                                        <input type="text" id="voucher_description" name="voucher_description" placeholder={i18n.t("Voucher Description")} value={tier.voucher_description} onChange={(e) => this.handleChange(e, index)} required />
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label htmlFor="voucher_amount">{i18n.t("Voucher Amount")} : <small>{tier.voucher_type === "Flat" ? `(${currency(this.props.distributor.country)})` : "(%)"}</small></label>
                                                                        <input type of="number" id="voucher_amount" name="voucher_amount" value={tier.voucher_amount} onChange={(e) => this.handleChange(e, index)} min="0" required />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                ))}
                                            </div>
                                            <div className="mb-3 mx-5">
                                                <button type="button" onClick={this.addTier} className="btn big-button form-control">{i18n.t("Add Tier")}</button>
                                            </div>
                                            {this.state.loading ? <Loading /> : (
                                                <div className="mb-5 mx-5">
                                                    <input type="submit" value={i18n.t("SUBMIT")} className="btn big-button form-control" />
                                                </div>
                                            )}
                                        </form>
                                    </div>
                                ) : null}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        distributor: state.distributor.distributor,
        token: state.distributor.token
    };
};

export default connect(mapStateToProps, null)(ReferralSetting);
